module.exports = __webpack_public_path__ + "img/contact_bg.47b51d78.jpg";